module.exports = __webpack_public_path__ + "img/group-women.cd95ebff.svg";